<template>
  <manage-ticket
    :ticket-data="ticketData"
    :modules="modules"
    :reference-number-types="referenceNumberTypes"
    :on-download="onDownloadHandler"
    :read-only="readOnly"
    :user="userProfile"
    :save-ticket="saveUserCase"
    :application="deTicketApplications.MIPE"
    :validate-reference-number="validateReferenceNumber"    
    :change-status-ticket="changeStatusTicket"
    :get-ticket-catalogues="getTicketCatalogues"
    @update-references="fetchReferenceNumberTypes"
  />
</template>

<script>
import store from "@/store/index";
import { ManageTicket } from "support-tickets";
import {
  getUserCaseById,
  getUserCaseReferenceNumberTypes,
  saveUserCase as _saveUserCase,
  downloadDocument,
  getPreviousContactInformation,
  validateReferenceNumber as _validateReferenceNumber,  
  changeStatusTicket as _changeStatusTicket,
  getTicketCatalogues as _getTicketCatalogues
} from "@/modules/helpdesk/api.js";
import documentsService from "@/services/documents";
import deTicketApplications from "@/utils/constants/deTicketApplications.js";
import objectToFormData from "object-to-formdata";

const initialModel = () => ({
  itemId: null,
  description: null,
  documents: [
    {
      tempId: 1,
      id: null,
      data: null,
      name: null
    }
  ],
  module: null,
  screen: null,
  referenceNumberTypes: [],
  email: null,
  telephone1: null,
  telephone2: null,
  statusId: null,
  workflowId: null,
  userContactInformation: {}
});

export default {
  name: "CreateTicket",
  components: { ManageTicket },
  data() {
    return {
      deTicketApplications,
      ticketData: initialModel(),
      readOnly: false,
      referenceNumberTypes: [],
      previousUserContactInfo: {}
    };
  },
  computed: {
    modules() {
      return store.getters["$_user/getSiteMap"].map(m => ({
        id: m.id,
        name: m.title,
        screens: m.children.map(item => ({
          id: item.id,
          name: item.title
        }))
      }));
    }   
  },
  async mounted() {
    const { id } = this.$route.params;
    await this.fetchReferenceNumberTypes();
    const contactInfo = await this.getPreviousContactInfo();
    if (id) {
      const { data } = await getUserCaseById(id);
      this.ticketData = {
        ...data,
        module: data.module,
        screen: data.screen,
        documents: data.documents ?? []
      };
      this.readOnly = true;
    } else {
      this.ticketData.userContactInformation = contactInfo;
    }
  },
  methods: {
    getTicketCatalogues(itemSubTypeId) {
      return _getTicketCatalogues(itemSubTypeId);
    },   
    validateReferenceNumber(reference, referenceType) {
      return _validateReferenceNumber(reference, referenceType);
    },
    async fetchReferenceNumberTypes(params) {
      const { data } = await getUserCaseReferenceNumberTypes(params);
      this.referenceNumberTypes = [...data];
    },
    saveUserCase(data) {
      const formData = objectToFormData(data, {
        indices: true,
        nullsAsUndefineds: true
      });
      (data.files || [])
        .filter(x => x?.name)
        .forEach((file, index) => {
          formData.append("files", file);
        });
      return _saveUserCase(formData);
    },
    async onDownloadHandler(fileId) {
      if (fileId) {
        await downloadDocument(fileId);
      } else {
        let file = {
          filename: document.filename,
          content: document.file,
          contentType: "application/pdf"
        };
        documentsService.downloadFile(file);
      }
    },
    async getPreviousContactInfo() {
      const { data } = await getPreviousContactInformation();
      return data;
    },
    changeStatusTicket(data)
    {
      return _changeStatusTicket(data);
    }
  }
};
</script>
